/**
 * Collects user environment information for agent context.
 * This provides common context that all agents can use.
 */
export function getUserEnvironment(): Record<string, unknown> {
  const now = new Date();

  // Get timezone info
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get locale/language
  const locale = navigator.language;

  // Get OS from user agent
  const userAgent = navigator.userAgent;
  let os = 'Unknown';
  if (userAgent.includes('Win')) os = 'Windows';
  else if (userAgent.includes('Mac')) os = 'macOS';
  else if (userAgent.includes('Linux')) os = 'Linux';
  else if (userAgent.includes('Android')) os = 'Android';
  else if (
    userAgent.includes('iOS') ||
    userAgent.includes('iPhone') ||
    userAgent.includes('iPad')
  )
    os = 'iOS';

  // Get browser
  let browser = 'Unknown';
  if (userAgent.includes('Chrome') && !userAgent.includes('Edg'))
    browser = 'Chrome';
  else if (userAgent.includes('Safari') && !userAgent.includes('Chrome'))
    browser = 'Safari';
  else if (userAgent.includes('Firefox')) browser = 'Firefox';
  else if (userAgent.includes('Edg')) browser = 'Edge';

  return {
    timestamp: now.toISOString(),
    localTime: now.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }),
    localDate: now.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }),
    timezone,
    locale,
    os,
    browser,
  };
}
